// Text extracted from the client's menu file (CARTA.GATO). PT/FR/IT fall back to Spanish.
export const CARTA = [
  {
    id: "primeras-lineas",
    name: { es: "Nuestras primeras líneas", en: "Our first courses" },
    items: [
      { es: "Ensalada Rosé Remolacha & Bonito del Norte", en: "Pink beetroot and North Atlantic tuna salad" },
      { es: "Tosta de Paleta Ibérica y Tomate", en: "Iberian shoulder ham and tomato toast" },
      { es: "Gyozas de pollo y verduras", en: "Chicken and vegetable gyozas" },
      { es: "Patatas de todos los colores", en: "Potatoes of every colour" },
    ],
  },
  {
    id: "sirena",
    name: { es: "Del cuento de la sirena", en: "From the mermaid's tale" },
    items: [
      { es: "Langostinos crujientes con alioli cítrico", en: "Crispy prawns with lime alioli" },
      { es: "Calamares a la andaluza con alioli cítrico", en: "Andalusian-style squid with citrus alioli" },
      { es: "Cazuela de la abuela: huevos rotos y gambón", en: "Grandmother's casserole: broken eggs and king prawn" },
      { es: "Brioche de calamar, alioli de ajonegro y lima", en: "Squid brioche, black garlic alioli and lime" },
    ],
  },
  {
    id: "cazador",
    name: { es: "Del cuento del cazador", en: "From the hunter's tale" },
    items: [
      { es: "Torreznos de Soria", en: "Torrezno from Soria" },
      { es: "La cazuela de Don Lucio de ibérico", en: "Don Lucio's Iberian pork casserole" },
      { es: "Picaña de vacuno", en: "Beef picanha" },
      { es: "Nuestro cachopo con patatas rústicas", en: "Our cachopo with rustic potatoes" },
    ],
  },
  {
    id: "postres",
    name: { es: "Y fueron felices y comieron...", en: "And they lived happily ever after and ate..." },
    items: [
      { es: "Coulant de chocolate y coulis de fresa", en: "Chocolate coulant with strawberry coulis" },
      { es: "Gofre del amor y la envidia", en: "The love and envy waffle" },
    ],
  },
];

export const tr = (obj, lang) => obj[lang] ?? obj.es;
